export default function UnelectSpecialCondition(state, payload){
  const {specialCondition} = payload;
  delete state.selectedSpecialConditions[specialCondition.id]
  return {...state}
}